import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

import { type SelectedApp } from '../../reducers';

const AppProviders = lazy(() => import('@app/components/AppProviders'));
const SelectedAppSetter = lazy(() => import('.'));

class SelectedAppSetterComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['projectTags'];
    }

    render() {
        const projectTags = this.jsonProp<SelectedApp[]>('projectTags') || [];
        const selectedApp = projectTags.filter((tag) => tag.contentIntegration)[0];

        return (
            <AppProviders>
                <SelectedAppSetter selectedApp={selectedApp} />
            </AppProviders>
        );
    }
}

customElements.define('editor-selected-app', SelectedAppSetterComponent);
